import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5c39ef99")

_pushScopeId("data-v-5c39ef99")
const _hoisted_1 = { class: "list-item" }
const _hoisted_2 = {
  key: 0,
  class: "image-container"
}
const _hoisted_3 = {
  key: 1,
  class: "list-item-detail"
}
const _hoisted_4 = { class: "list-item-detail__desc" }
const _hoisted_5 = { class: "p-mb-2 doctor-name -bold" }
const _hoisted_6 = { class: "facility" }
const _hoisted_7 = { class: "dept" }
const _hoisted_8 = { class: "doctor-description" }
const _hoisted_9 = {
  key: 0,
  class: "-medium"
}
const _hoisted_10 = {
  key: 0,
  class: "favorites"
}
const _hoisted_11 = {
  key: 1,
  class: "button"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.state.item.Image)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("img", {
            src: _ctx.state.item.Image.valueOf(),
            alt: _ctx.state.item.Name.valueOf()
          }, null, 8, ["src", "alt"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.isDefaultDetail)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("h5", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.item.Name) + " ", 1),
              _createVNode("span", _hoisted_6, _toDisplayString(_ctx.item.Facility), 1),
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.item.Dept), 1)
            ]),
            _createVNode("div", _hoisted_8, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getProfiles(_ctx.state.item.Profiles), (p, i) => {
                return (_openBlock(), _createBlock(_Fragment, { key: i }, [
                  (i < 2)
                    ? (_openBlock(), _createBlock("span", _hoisted_9, _toDisplayString(p), 1))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]),
            _renderSlot(_ctx.$slots, "desc", {}, undefined, true)
          ]),
          (_ctx.$slots.favorites)
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                _renderSlot(_ctx.$slots, "favorites", {}, undefined, true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.$slots.button)
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                _renderSlot(_ctx.$slots, "button", {}, undefined, true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.$slots.detail)
        ? _renderSlot(_ctx.$slots, "detail", { key: 2 }, undefined, true)
        : _createCommentVNode("", true),
    (_ctx.$slots.footer)
      ? _renderSlot(_ctx.$slots, "footer", { key: 3 }, undefined, true)
      : _createCommentVNode("", true)
  ]))
})